// src/components/Navbar.jsx
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import logokreasi from '../assets/img/logo kreasi.jpg';
import logoskk from '../assets/img/logo skk fix.png';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const menuRef = useRef(null);

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const closeAll = () => {
    setMobileOpen(false);
    setOpenDropdown(null);
  };

  // Tutup saat klik di luar panel menu (mobile)
  useEffect(() => {
    if (!mobileOpen) return;

    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        closeAll();
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') closeAll();
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [mobileOpen]);

  // Kunci scroll body saat menu terbuka
  useEffect(() => {
    if (mobileOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    return () => document.body.classList.remove('no-scroll');
  }, [mobileOpen]);

  // Jika resize ke desktop, tutup menu
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 992 && mobileOpen) closeAll();
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [mobileOpen]);

  return (
    <div>
      <div className="contact-bar">
        <span>Hubungi Kami: Hotline 📞 082114692102</span>
        <div className="social-icons">
          <a href="https://wa.me/+6282114692102" target="_blank" rel="noreferrer"><i className="fab fa-whatsapp" /></a>
          <a href="https://youtube.com/@komiteskktransportasi?si=kZu4h1QTSKw2GOQt" target="_blank" rel="noreferrer"><i className="fab fa-youtube" /></a>
          <a href="https://www.instagram.com/setkomskktranslog?igsh=MXI2aXEyazllYmowZQ==" target="_blank" rel="noreferrer"><i className="fab fa-instagram" /></a>
        </div>
      </div>

      <nav className="navbar" ref={menuRef}>
        <div className="logo">
          <img src={logoskk} alt="Logo SKKNI" />
          <img src={logokreasi} alt="Logo Kreasi" />
        </div>

        {/* Tombol hamburger (toggle buka/tutup) */}
        <button
          className="hamburger-btn"
          aria-label="Toggle navigation"
          aria-expanded={mobileOpen}
          aria-controls="primary-navigation"
          onClick={() => setMobileOpen((v) => !v)}
        >
          {mobileOpen ? '✕ Tutup' : '☰ Menu'}
        </button>

        {/* Overlay untuk click-outside (muncul hanya saat open) */}
        {mobileOpen && (
          <button
            className="nav-overlay"
            aria-label="Close menu overlay"
            onClick={closeAll}
          />
        )}

        {/* Panel menu */}
        <ul id="primary-navigation" className={`nav-links ${mobileOpen ? 'open' : ''}`}>
          <li><Link to="/" onClick={closeAll}>Beranda</Link></li>

          <li
            className={`dropdown ${openDropdown === 'organisasi' ? 'open' : ''}`}
            onMouseEnter={() => window.innerWidth > 992 && setOpenDropdown('organisasi')}
            onMouseLeave={() => window.innerWidth > 992 && setOpenDropdown(null)}
          >
            <button className="dropbtn" onClick={() => toggleDropdown('organisasi')}>Organisasi</button>
            <ul className="dropdown-content">
              <li><Link to="/tentang-kami" onClick={closeAll}>Tentang Kami</Link></li>
              <li><Link to="/struktur-organisasi" onClick={closeAll}>Struktur Organisasi</Link></li>
              <li><Link to="/daftar-lsp" onClick={closeAll}>Daftar LSP</Link></li>
              <li><Link to="/daftar-lembaga-diklat" onClick={closeAll}>Daftar Lembaga Diklat</Link></li>
              <li><Link to="/daftar-asosiasi" onClick={closeAll}>Daftar Asosiasi</Link></li>
            </ul>
          </li>

          <li
            className={`dropdown ${openDropdown === 'regulasi' ? 'open' : ''}`}
            onMouseEnter={() => window.innerWidth > 992 && setOpenDropdown('regulasi')}
            onMouseLeave={() => window.innerWidth > 992 && setOpenDropdown(null)}
          >
            <button className="dropbtn" onClick={() => toggleDropdown('regulasi')}>Regulasi</button>
            <ul className="dropdown-content">
              <li><Link to="/peraturan" onClick={closeAll}>Peraturan</Link></li>
              <li><Link to="/daftar-skkk" onClick={closeAll}>SKKK</Link></li>
              <li><Link to="/daftar-skkni" onClick={closeAll}>SKKNI</Link></li>
            </ul>
          </li>

          <li><Link to="/agenda" onClick={closeAll}>Agenda</Link></li>

          <li
            className={`dropdown ${openDropdown === 'layanan' ? 'open' : ''}`}
            onMouseEnter={() => window.innerWidth > 992 && setOpenDropdown('layanan')}
            onMouseLeave={() => window.innerWidth > 992 && setOpenDropdown(null)}
          >
            <button className="dropbtn" onClick={() => toggleDropdown('layanan')}>Layanan</button>
            <ul className="dropdown-content">
              <li><a href="https://bpsdm.kemenhub.go.id/setkomskk/admin/skkk" target="_blank" rel="noreferrer">Pengajuan SKKK</a></li>
              <li><a href="https://bpsdm.kemenhub.go.id/setkomskk/admin/register" target="_blank" rel="noreferrer">Pengajuan SKKI</a></li>
              <li><a href="https://bpsdm.kemenhub.go.id/setkomskk/admin/register" target="_blank" rel="noreferrer">Pengajuan SKKNI</a></li>
              <li><a href="https://bpsdm.kemenhub.go.id/setkomskk/admin/register" target="_blank" rel="noreferrer">Pengajuan LSP</a></li>
              <li><a href="https://bpsdm.kemenhub.go.id/setkomskk/admin/register" target="_blank" rel="noreferrer">Pengajuan Skema</a></li>
              <li><a href="https://bpsdm.kemenhub.go.id/setkomskk/admin/register" target="_blank" rel="noreferrer">Pengajuan Asesor</a></li>
              <li><Link to="/dokumen" onClick={closeAll}>Dokumen</Link></li>
            </ul>
          </li>

          <li><Link to="/survey" onClick={closeAll}>Survey</Link></li>

          <li
            className={`dropdown ${openDropdown === 'media' ? 'open' : ''}`}
            onMouseEnter={() => window.innerWidth > 992 && setOpenDropdown('media')}
            onMouseLeave={() => window.innerWidth > 992 && setOpenDropdown(null)}
          >
            <button className="dropbtn" onClick={() => toggleDropdown('media')}>Media</button>
            <ul className="dropdown-content">
              <li><Link to="/galeri" onClick={closeAll}>Galeri</Link></li>
              <li><Link to="/berita" onClick={closeAll}>Berita</Link></li>
            </ul>
          </li>

          <li
            className={`dropdown ${openDropdown === 'portal' ? 'open' : ''}`}
            onMouseEnter={() => window.innerWidth > 992 && setOpenDropdown('portal')}
            onMouseLeave={() => window.innerWidth > 992 && setOpenDropdown(null)}
          >
            <button className="dropbtn" onClick={() => toggleDropdown('portal')}>Portal</button>
            <ul className="dropdown-content">
              <li><a href="https://bpsdm.kemenhub.go.id/setkomskk/admin/login" target="_blank" rel="noreferrer">Login</a></li>
              <li><a href="https://bpsdm.kemenhub.go.id/setkomskk/admin/register" target="_blank" rel="noreferrer">Register</a></li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
